import { render, staticRenderFns } from "./task.vue?vue&type=template&id=ca08ed24&scoped=true&"
import script from "./task.vue?vue&type=script&lang=ts&"
export * from "./task.vue?vue&type=script&lang=ts&"
import style0 from "./task.vue?vue&type=style&index=0&id=ca08ed24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca08ed24",
  null
  
)

export default component.exports